"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const base_1 = require("./base");
exports.default = new base_1.FlowNodeSpec({
    name: 'Find Data Record By Id',
    description: 'Find a single data record by id',
});
//# sourceMappingURL=find-data-record-by-id.js.map